import { render, staticRenderFns } from "./inspectScreenEasy.vue?vue&type=template&id=385a186e&scoped=true"
import script from "./inspectScreenEasy.vue?vue&type=script&lang=js"
export * from "./inspectScreenEasy.vue?vue&type=script&lang=js"
import style0 from "./inspectScreenEasy.vue?vue&type=style&index=0&id=385a186e&prod&lang=scss&scoped=true"
import style1 from "./inspectScreenEasy.vue?vue&type=style&index=1&id=385a186e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a186e",
  null
  
)

export default component.exports